// src/pages/Analise/analiseLocation.js
// Helpers puros de geolocalização/clima usados na criação de análise.
// Extraídos do AnaliseFormModal para reuso no AnaliseAutoCreateModal.

export const parseNumber = (value) => {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : null;
};

export const buildLocationSummary = (raw = {}) => {
    const neighborhood = String(raw.neighborhood || raw.district || '').trim();
    const city = String(raw.city || raw.locality || raw.town || '').trim();
    const state = String(raw.state || raw.region || '').trim();
    const zipCode = String(
        raw.zipCode || raw.postcode || raw.postalCode || ''
    ).trim();
    const formatted = [neighborhood, city, state].filter(Boolean).join(', ');

    return {
        neighborhood,
        city,
        state,
        zipCode,
        formatted:
            formatted ||
            [city, state].filter(Boolean).join(' - ') ||
            'Localizacao confirmada',
    };
};

export const composeLocationQuery = (client = {}) =>
    [
        client.street,
        client.number,
        client.neighborhood,
        client.city,
        client.state,
        client.zipCode,
    ]
        .map((part) => String(part || '').trim())
        .filter(Boolean)
        .join(', ');

export const fetchLocalWeather = async (lat, lon) => {
    try {
        const url1 = `https://api.open-meteo.com/v1/forecast?latitude=${lat}&longitude=${lon}&current_weather=true`;
        const res1 = await fetch(url1);
        if (res1.ok) {
            const data1 = await res1.json();
            if (data1?.current_weather?.temperature !== undefined) {
                return data1.current_weather.temperature;
            }
        }
    } catch (e) {
        console.warn('Open-Meteo falhou, tentando fallback wttr.in...');
    }
    try {
        const url2 = `https://wttr.in/${lat},${lon}?format=j1`;
        const res2 = await fetch(url2);
        if (res2.ok) {
            const data2 = await res2.json();
            if (data2?.current_condition?.[0]?.temp_C !== undefined) {
                return parseFloat(data2.current_condition[0].temp_C);
            }
        }
    } catch (e) {
        console.error('Ambas as APIs de clima falharam:', e);
    }
    return null;
};

export const searchAddressForward = async (query) => {
    try {
        const url = `https://nominatim.openstreetmap.org/search?format=jsonv2&q=${encodeURIComponent(query)}&limit=1`;
        const res = await fetch(url, {
            headers: { 'Accept-Language': 'pt-BR' },
        });
        if (res.ok) {
            const data = await res.json();
            if (data && data.length > 0) {
                return {
                    latitude: parseFloat(data[0].lat),
                    longitude: parseFloat(data[0].lon),
                };
            }
        }
    } catch (e) {}

    try {
        const urlPhoton = `https://photon.komoot.io/api/?q=${encodeURIComponent(query)}&limit=1`;
        const res = await fetch(urlPhoton);
        if (res.ok) {
            const data = await res.json();
            if (data.features && data.features.length > 0) {
                const [lon, lat] = data.features[0].geometry.coordinates;
                return { latitude: lat, longitude: lon };
            }
        }
    } catch (e) {}

    return null;
};
